import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconTasklistSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M12.6805 4.26721C13.0852 4.64301 13.1086 5.27574 12.7328 5.68046L6.23282 12.6805C6.03725 12.8911 5.76052 13.0074 5.47321 12.9996C5.1859 12.9919 4.9158 12.861 4.7318 12.6402L2.2318 9.64019C1.87824 9.21591 1.93556 8.58535 2.35984 8.23178C2.78412 7.87822 3.41468 7.93554 3.76825 8.35982L5.54062 10.4867L11.2672 4.31955C11.643 3.91484 12.2758 3.89141 12.6805 4.26721Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
